// bind an identifier function given a definition of the identifiers
export const bindIdentifier = identifiers => subject => Object.keys(identifiers).find(key => identifiers[key](subject))

// bind a property getter selector function given an identifier function and a definition of the getters
export const bindPropertyGetter = identifier => getters => (thing = {}, ...rest) => {
	const type = identifier(thing)
	let getter = getters[type]
	if (!getter) {
		getter = getters.default
	}
	if (typeof getter === 'function') {
		return getter(thing, ...rest)
	}
	return getter
}



// WEBPACK FOOTER //
// ./src/utilities/Data/index.js